import React from "react";
import "../styles/pagination.css";

interface Props {
  setcurrentPage: (num: number) => void;
  pagination: Record<string, number>;
  setPagination: (num: Record<string, any>) => void;
  limitNum: number;
  setLimitNum: (num: number) => void;
}

const getPageNumbers = (page: number, totalPages: number) => {
  const pages: (number | string)[] = [];

  if (totalPages <= 5) {
    for (let i = 1; i <= totalPages; i++) pages.push(i);
    return pages;
  }

  if (page <= 2) {
    pages.push(1, 2, 3, "...", totalPages);
  } else if (page > totalPages - 2) {
    pages.push(1, "...", totalPages - 2, totalPages - 1, totalPages);
  } else {
    pages.push(1, "...", page - 1, page, page + 1, "...", totalPages);
  }
  return pages;
};

const Pagination: React.FC<Props> = ({ setcurrentPage, pagination, setPagination, limitNum, setLimitNum }) => {
  const { totalResults = 0, totalPages = 1, page = 1, limit = 10 } = pagination || {};
  const pages = getPageNumbers(page, totalPages);

  const handlePageChange = (newPage: number) => {
    if (newPage < 1 || newPage > totalPages || newPage === page) return;
    setPagination({ ...pagination, page: newPage });
    setcurrentPage(newPage);
  };

  return (
    <div className="pagination" style={{ display: "flex", alignItems: "center", gap: 4 }}>
      <div
        className={`pageNoblock${page === 1 ? " pg_disable" : ""}`}
        style={{ cursor: page === 1 ? "not-allowed" : "pointer" }}
        onClick={() => handlePageChange(page - 1)}
      >
        ‹ Previous
      </div>
      {pages.length > 0 ? (
        pages.map((p, idx) =>
          typeof p === "number" ? (
            <div
              key={p}
              className={`pageNoblock${p === page ? " pg_active" : ""}`}
              style={{ cursor: p === page ? "default" : "pointer" }}
              onClick={() => handlePageChange(p)}
            >
              {p}
            </div>
          ) : (
            <div key={"ellipsis" + idx} className="pageNoblock" style={{ pointerEvents: "none", opacity: 0.6 }}>
              {p}
            </div>
          )
        )
      ) : (
        <div className={`pageNoblock${" pg_active"}`} style={{ cursor: "default" }}>
          1
        </div>
      )}
      <div
        className={`pageNoblock${page === totalPages ? " pg_disable" : ""}`}
        style={{ cursor: page === totalPages ? "not-allowed" : "pointer" }}
        onClick={() => handlePageChange(page + 1)}
      >
        Next ›
      </div>
      <span className="pg_info">
        Showing {limit * (page - 1) + 1}-{Math.min(limit * page, totalResults)} of {totalResults}
      </span>
    </div>
  );
};

export default Pagination;
